import styled from "styled-components";
import { useNavigate, } from "react-router-dom";
import { DateTime, } from "luxon";

import { Flow, Button, } from "@bracket/ui";
import { useVaults, } from "@bracket/platform/store";
import { getVaultClaimTime, } from "@bracket/parlance";

import type { Vault, } from "@bracket/types";
import type { TransactionLogEntry, } from "@gql/types/graphql";


type LabelFnProps = {
	time?: TransactionLogEntry["scheduled_time"];
	epoch_available?: TransactionLogEntry["epoch_available"];
}

type LabelFn = (props: LabelFnProps) => string|React.ReactNode;

type StatusConfig = {
	path: string | null;
	label: LabelFn;
};

// REDEEM for brketh, and Claim
const STATUS_CONFIG: Record<string, StatusConfig>  = {
	BRKT_BUY: {
		path: null,
		label: () => "Buy",
	},
	BRKT_SELL_SCHEDULED: {
		path: null,
		label: ({time}) => `Redeemable on: ${DateTime.fromISO(time).toLocaleString(DateTime.DATETIME_MED)}`,
	},
	BRKT_SELL_READY: {
		path: "/invest", // TODO update
		label: () => "Redeem",
	},
	BRKT_SELL_COMPLETE: {
		path: null,
		label: () => "Redeem Complete",
	},
	VAULT_BUY: {
		path: null,
		label: () => "Invest",
	},
	VAULT_SELL_SCHEDULED: {
		path: null,
		label: ({ time, }) => (
			<LabelBrace>
				<div title={DateTime.fromISO(time).toLocaleString(DateTime.DATETIME_MED)}>Withdraw Scheduled</div>
			</LabelBrace>
		),
	},
	VAULT_SELL_READY: {
		path: "/invest", // TODO to strategy details
		label: ( P ) => {
			return `Claimable`;
		}
	},
	VAULT_SELL_COMPLETE: {
		path: null,
		label: () => "Withdraw Complete",
	},
};

interface StatusButtonProps {
	type: TransactionLogEntry["trxn_type"];
	status: TransactionLogEntry["status"];
	symbol: Vault["symbol"];
	epoch_available?: TransactionLogEntry["epoch_available"];
	scheduled_time?: TransactionLogEntry["scheduled_time"];
}

export const StatusButton: React.FC<StatusButtonProps> = ({
	type,
	status,
	symbol,
	epoch_available,
	scheduled_time,
}) => {

	const navigate = useNavigate();

	const { ready, available, } = useVaults();

	if(!ready) {
		return null;
	}

	if(type === "MINT") {
		return null;
	}
	if(!status) {
		console.warn("StatusButton:: no status received");
		return null;
	}

	const vault = available.find(v => v.symbol === symbol);

	if(!vault) {
		return null;
	}

	const { label, path, } = STATUS_CONFIG[status];
	const result = label({ time:scheduled_time, epoch_available, symbol, });
	if(!path) {
		return <>{result}</>;
	}
	return (
		<div title={DateTime.fromISO(scheduled_time).toLocaleString(DateTime.DATETIME_MED)}>
			<Button
				onClick={() => navigate(path!)}
				variant="primary"
				size="sm"
				label={result}
			/>
		</div>
	);
};

const LabelBrace = styled(Flow)`
	align-items: flex-start;
	justify-content: flex-start;
`;
